<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { format, parseISO } from 'date-fns';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  event: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const dialogRef = ref(null);

const formattedTime = computed(() => {
  if (!props.event?.startsAt) return '';
  if (props.event.allDay) return format(parseISO(props.event.startsAt), 'PPP');
  return format(parseISO(props.event.startsAt), 'PPPp');
});

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="event.title || t('CALENDAR.EVENT_DETAILS.TITLE')"
    :description="formattedTime"
    :show-confirm-button="false"
    :cancel-button-label="t('DIALOG.BUTTONS.CANCEL')"
  >
    <div class="flex flex-col gap-3 text-sm text-n-slate-11">
      <div v-if="event.location" class="flex flex-col gap-1">
        <span class="font-medium text-n-slate-12">
          {{ t('CALENDAR.EVENT_DETAILS.LOCATION') }}
        </span>
        <span>{{ event.location }}</span>
      </div>
      <div v-if="event.description" class="flex flex-col gap-1">
        <span class="font-medium text-n-slate-12">
          {{ t('CALENDAR.EVENT_DETAILS.DESCRIPTION') }}
        </span>
        <span class="whitespace-pre-line">{{ event.description }}</span>
      </div>
    </div>
  </Dialog>
</template>
